import React, {useContext, useEffect} from 'react'
import { Form, InputNumber } from 'antd'
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeItemQuantity = ({rowId}) => {
    const [form] = Form.useForm()
    const {rowData} = useContext(RecipeConText)
    const [rowState, setRowState] = rowData

    useEffect(() => {
        form.setFieldsValue({
            quantity: rowState[rowId].quantity
        })
    }, [])

    const handleQuantityChange = (list) => {
        let mockRows = Object.assign({}, rowState)
        mockRows[rowId].quantity = list.quantity
        setRowState(mockRows)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
                wrapperCol={{span: 24}}
            >
                <Form.Item
                    name={'quantity'}
                >
                    <InputNumber    onChange={() => handleQuantityChange(form.getFieldsValue())}  step={0.1} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default RecipeItemQuantity